<template>
	<page>
		<dl class="config">
			<dt>已选指标<span>（按住拖拽调整顺序，最多展示6个）</span></dt>
			<dd>
				<c-drag-sort v-model="selected" class="list flex-wrap" @sort="saveHandle">
					<template #default="{item, id, index}">
						<c-drag-item :key="id" class="item flex-center" @click.native="removeHandle(index)">
							<span>{{item.name}}</span>
							<ins class="flex-center" style="background: #aaa;"><i class="tf">&#xe60e;</i></ins>
						</c-drag-item>
					</template>
				</c-drag-sort>
			</dd>
		</dl>
		<dl class="config">
			<dt>可选指标</dt>
			<dd>
				<ul class="list flex-wrap">
					<li v-for="(item, i) in list" :key="i" class="item flex-center" @click="addHandle(i)">
						<span>{{item.name}}</span>
						<ins class="flex-center" style="background: var(--color-main);"><i class="tf">&#xe64d;</i></ins>
					</li>
				</ul>
			</dd>
		</dl>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				selected: [],
				list: []
			}
		},

		mounted() {
			this.request({
				url: '/app/workbench/board/config',
				success: data => {
					this.selected = data.selected_list;
					this.list = data.available_list;
				}
			});
		},

		methods: {
			removeHandle(index) {
				if (this.selected.length == 1) {
					this.$message({
						message: '至少要选择一项指标'
					});
					return;
				}
				this.list.push(this.selected.splice(index, 1)[0]);
				this.saveHandle();
			},

			saveHandle() {
				this.$nextTick(() => {
					this.request({
						url: '/app/workbench/board/config/edit',
						data: {
							metric_codes: this.selected.map(item => item.code).join(',')
						}
					});
				});
			},

			addHandle(index) {
				if (this.selected.length >= 6) {
					this.$message({
						message: '最多只能选择6项指标'
					});
					return;
				}
				this.selected.push(this.list.splice(index, 1)[0]);
				this.saveHandle();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.config {
		padding: 0 .24rem;
		margin-bottom: .2rem;
		background: #fff;

		dt {
			height: 1rem;
			line-height: 1.1rem;
			font-size: .3rem;
			font-weight: 600;

			span {
				font-size: .26rem;
				font-weight: normal;
				color: #666;
			}
		}

		dd {
			.list {
				gap: .24rem;
				padding-bottom: .3rem;

				.item {
					position: relative;
					box-sizing: border-box;
					width: 2.18rem;
					height: 1rem;
					border: .02rem solid #ddd;
					border-radius: .12rem;
					font-size: .28rem;
					color: #333;
					background: #fff;

					ins {
						position: absolute;
						right: .08rem;
						top: .08rem;
						width: .28rem;
						height: .28rem;
						border-radius: 50%;
						font-size: .2rem;
						color: #fff;
					}
				}
			}
		}
	}
</style>